import { render } from "./vagentcensusfd.vue?vue&type=template&id=62cc3c2c&scoped=true"
import script from "./vagentcensusfd.vue?vue&type=script&lang=js"
export * from "./vagentcensusfd.vue?vue&type=script&lang=js"

import "./vagentcensusfd.vue?vue&type=style&index=0&id=62cc3c2c&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62cc3c2c"]])

export default __exports__